import {DI_TOKENS} from '@/di/di.tokens';
import {AnalyticsFirstImprovementType} from '@/services/TrackingService/TrackingService.constants';

import {injected} from 'brandi';

import {HttpError} from '@specials/project-user';

import {ErrorsService} from '@/services/ErrorsService/ErrorsService';
import {LoggerService} from '@/services/LoggerService/LoggerService';
import {IProjectApi} from '@/services/ProjectApi/types';
import {TrackingService} from '@/services/TrackingService/TrackingService';
import {GameStatusService} from '@/services/shared/GameStatusService/GameStatusService';
import {ImprovementsStore} from '@/stores/ImprovementsStore/ImprovementsStore';

export class ImprovementsService {
  constructor(
    private readonly projectApi: IProjectApi,
    private readonly improvementsStore: ImprovementsStore,
    private readonly loggerService: LoggerService,
    private readonly trackingService: TrackingService,
    private readonly errorsService: ErrorsService,
    private readonly gameStatusService: GameStatusService,
  ) {}

  public async fetchImprovementsStatic(): Promise<void> {
    try {
      this.improvementsStore.setLoadingFetchStatus();
      this.improvementsStore.clearErrorFetchData();

      const response = await this.projectApi.fetchImprovementsStatic();

      this.improvementsStore.setImprovementsStatic(response.payload.improvements);

      this.improvementsStore.setSuccessFetchStatus();
    } catch (error) {
      this.loggerService.logHttpError(error as HttpError);

      if (this.errorsService.isErrorRecalculationLeagues(error)) {
        this.gameStatusService.setStatusLeaguesRecalculation();
      } else {
        this.improvementsStore.setErrorFetchStatus();
        this.improvementsStore.setErrorFetchData(error);
      }
    }
  }

  public setDetailImprovementId = (id: string): void => {
    if (!this.improvementsStore.hasBoughtImprovement() && this.improvementsStore.isFirstImprovement(id)) {
      this.trackingService.trackClickToFirstImprovement(AnalyticsFirstImprovementType.Upgrade);
    }
    this.improvementsStore.setDetailImprovementId(id);
  };

  public setImprovementFrozenUntilNowById = (id: string): void => {
    this.improvementsStore.setImprovementFrozenUntilNowById(id);
  };

  public clearDetailImprovementId = (): void => {
    this.improvementsStore.setDetailImprovementId(null);
  };

  public clearImprovementsStatus(): void {
    this.improvementsStore.setIdleFetchStatus();
  }

  public clearImprovementsErrorData(): void {
    this.improvementsStore.clearErrorFetchData();
  }
}

injected(
  ImprovementsService,
  DI_TOKENS.projectApi,
  DI_TOKENS.improvementsStore,
  DI_TOKENS.loggerService,
  DI_TOKENS.trackingService,
  DI_TOKENS.errorsService,
  DI_TOKENS.gameStatusService,
);
